module.exports = __webpack_public_path__ + "img/un.18c782f8.svg";